import React from 'react';

function ContracsWithErrorsList({ list }) {
    return (
        <ul style={{ listStyle: 'none', padding: 0 }}>
            {list.map(({ contract }) => (
                <li key={contract}>Contrato: {contract}</li>
            ))}
        </ul>
    );
}

export default ContracsWithErrorsList;
